import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'ar',
    supportedLngs: ['en', 'ar'],
    ns: ['translation'],
    defaultNS: 'translation',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage'],
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;

// Change Bootstrap CSS based on language direction
const rtlLanguages = ['ar', 'he', 'fa', 'ur'];

const BOOTSTRAP = {
  ltr: 'https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css',
  rtl: 'https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.rtl.min.css'
};

const INTEGRITY = {
  ltr: "sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC",
  rtl: "sha384-gXt9imSW0VcJVHezoNQsP+TNrjYXoGcrqBZJpry9zJt8PCQjobwmhMGaDHTASo9N"
}

function setBootstrapDir(dir) {
  try {
    const link = document.getElementById('bootstrap-css');
    if (!link) return;
    const target = dir === 'rtl' ? BOOTSTRAP.rtl : BOOTSTRAP.ltr;
    const integrity = dir === 'rtl' ? INTEGRITY.rtl : INTEGRITY.ltr;
    if (link.integrity !== integrity) link.integrity = integrity;
    if (link.href !== target) link.href = target;
  } catch (e) {
    
  }
}

i18n.on('languageChanged', (lng) => {
  try {
    const dir = rtlLanguages.includes(lng) ? 'rtl' : 'ltr';
    document.documentElement.lang = lng || 'ar';
    document.documentElement.dir = dir;
    setBootstrapDir(dir);
  } catch (err) {
    
  }
});

const initialLng = i18n.language || localStorage.getItem('i18nextLng') || 'ar';
i18n.emit('languageChanged', initialLng);